import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import VueAxios from 'vue-axios';
import jquery from 'jquery';
import store from './store'

import clipboard from 'clipboard';
import Message from 'vue-m-message'
import 'vue-m-message/dist/index.css'
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import thousands from './filter/thousands'
import vnthousands from './filter/vnthousands'

Vue.use(VueLoading);

Vue.use(Message) 

Vue.prototype.clipboard = clipboard;
Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'

Vue.filter("thousands", thousands);
Vue.filter("vnthousands", vnthousands);
Vue.use(VueClipboard)

let request = [];
axios.interceptors.request.use(
  config => {
    store.dispatch('setLoad',true);
    request.push(config.url.split('?')[0])
    return config;
  },
  error => Promise.reject(error)
);
axios.interceptors.response.use(
  res => {
    request.splice(request.indexOf(res.config.url.split('?')[0]),1);
    if(request.length == 0) {
      store.dispatch('setLoad',false);
    }
    return res
  },
  err => {
    request.splice(request.indexOf(err.config.url.split('?')[0]),1);
    if(request.length == 0) {
      store.dispatch('setLoad',false);
    }
  }
)

window.jquery = window.$ = jquery
Vue.use(VueAxios, axios)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
